---
title: "Quickstart"
description: "Get started with AI Apps in under 5 minutes."
---

# Quickstart

Get your first AI app running in just a few steps.

## Installation

```bash
npm install aiapps
```

## Create your first app

```typescript
import { createApp } from "aiapps";

const app = createApp({
  name: "my-first-app",
});

app.flow("hello", async (ctx) => {
  const name = await ctx.ask("What's your name?");
  return ctx.respond(`Hello, ${name}! Welcome to AI Apps.`);
});

app.start();
```

## Run it

```bash
npx tsx index.ts
```

That's it. You've built your first AI app.

## What's Next?

Explore the core concepts to learn about flows, tools, and state management.
